import { render } from "./ComputationTiles.vue?vue&type=template&id=507d2312"
import script from "./ComputationTiles.vue?vue&type=script&lang=js"
export * from "./ComputationTiles.vue?vue&type=script&lang=js"

import "./ComputationTiles.vue?vue&type=style&index=0&id=507d2312&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__